var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Summary',{attrs:{"details":_vm.details}}),_c('kst-section',{attrs:{"title":_vm.invoiceItemsSectionTitle}},[_c('InvoiceProfit',{attrs:{"items":_vm.details.Items}})],1),_c('kst-section',{attrs:{"title":_vm.rtninvoiceSectionTitle}},[_c('RtnInvoiceProfit',{attrs:{"dataList":_vm.profitData.RtnInvoiceList}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }